import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Navbar from './Navbar';
import NurseTopNavbar from '../NurseApp/Layout/NurseTopNavbar';
import { setDocumentTitle } from '../../utils/documentTitle';
import ProtectedRoute from './ProtectedRoute';
import { startReminderService } from '../../utils/videoCallReminder';
import MapHome from '../Home/MapHome';
import WelcomePage from '../Welcome/WelcomePage';
import AngelCareWelcomePage from '../Welcome/AngelCareWelcomePage';
import LoginNew from '../Auth/LoginNew';
import RegisterNew from '../Auth/RegisterNew';
import GirlProfile from '../GirlProfile/GirlProfile';
import AdminPanel from '../AdminPanel/AdminPanel';
import BookingHistory from '../Booking/BookingHistory';
import MomoDashboard from '../Momo/MomoDashboard';
import GirlDashboard from '../Girl/GirlDashboard';
import TripPlansPage from '../TripPlan/TripPlansPage';
import AcceptInvitation from '../TripPlan/AcceptInvitation';
import CheckinPage from '../Checkin/CheckinPage';
import ScanQRPage from '../Checkin/ScanQRPage';
import AgodaPage from '../Agoda/AgodaPage';
import MarketplaceHome from '../Marketplace/MarketplaceHome';
import StoreManagement from '../Marketplace/StoreManagement';
import Cart from '../Marketplace/Cart';
import FavoritesPage from '../Marketplace/FavoritesPage';
import BannerDashboard from '../Customer/BannerDashboard';
import OrdersList from '../Marketplace/OrdersList';
import OrderDetail from '../Marketplace/OrderDetail';
import AuctionManagement from '../Marketplace/AuctionManagement';
import AuctionsList from '../Marketplace/AuctionsList';
import AuctionDetail from '../Marketplace/AuctionDetail';
import BuyerRequestManagement from '../Marketplace/BuyerRequestManagement';
import MyVideoCallRequests from '../Marketplace/MyVideoCallRequests';
import ProductDetail from '../Marketplace/ProductDetail';
import StoreDetail from '../Marketplace/StoreDetail';
import StoresList from '../Marketplace/StoresList';
import ProductsList from '../Marketplace/ProductsList';
import FarmDashboard from '../Marketplace/FarmDashboard';
import ChatPage from '../Marketplace/ChatPage';
import VideoCall from '../VideoCall/VideoCall';
import ProfileSettings from '../Profile/ProfileSettings';
import ReviewsPage from '../Review/ReviewsPage';
import PWAInstallPrompt from '../PWA/PWAInstallPrompt';
import LineBrowserPrompt from '../Browser/LineBrowserPrompt';
import SetAdminRole from '../Debug/SetAdminRole';
import DailyBonusModal from '../TCoins/DailyBonusModal';
import { ROLES } from '../../utils/roleManager';
import { JOB_ROLES } from '../../data/nurseAppModels';
import { useAuth } from '../../context/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';
import NurseHomePage from '../NurseApp/Home/NurseHomePage';
import FeatureGuard from '../NurseApp/FeatureGuard';
import TeamListPage from '../NurseApp/Team/TeamListPage';
import TeamDetailPage from '../NurseApp/Team/TeamDetailPage';
import TeamConfigPage from '../NurseApp/Team/TeamConfigPage';
import BedManagementPage from '../NurseApp/Team/BedManagementPage';
import EquipmentListPage from '../NurseApp/Equipment/EquipmentListPage';
import EquipmentPlanManagementPage from '../NurseApp/Equipment/EquipmentPlanManagementPage';
import InspectionJourneyPage from '../NurseApp/Equipment/InspectionJourneyPage';
import InspectionSuccessPage from '../NurseApp/Equipment/InspectionSuccessPage';
import MyInspectionsPage from '../NurseApp/Equipment/MyInspectionsPage';
import InspectionApprovalDashboard from '../NurseApp/Equipment/InspectionApprovalDashboard';
import InspectionReviewPage from '../NurseApp/Equipment/InspectionReviewPage';
import CompareInspectionsPage from '../NurseApp/Equipment/CompareInspectionsPage';
import StockManagementPage from '../NurseApp/Equipment/StockManagementPage';
import EquipmentDashboardPage from '../NurseApp/Equipment/EquipmentDashboardPage';
import EquipmentDetailPage from '../NurseApp/Equipment/EquipmentDetailPage';
import CatalogManagementPage from '../NurseApp/Equipment/CatalogManagementPage';
import CreateEquipmentPage from '../NurseApp/Equipment/CreateEquipmentPage';
import BorrowEquipmentPage from '../NurseApp/Equipment/BorrowEquipmentPage';
import MyBorrowedEquipmentPage from '../NurseApp/Equipment/MyBorrowedEquipmentPage';
import BorrowManagementPage from '../NurseApp/Equipment/BorrowManagementPage';
import RepairRequestPage from '../NurseApp/Equipment/RepairRequestPage';
import MyRepairRequestsPage from '../NurseApp/Equipment/MyRepairRequestsPage';
import RepairManagementPage from '../NurseApp/Equipment/RepairManagementPage';
import EquipmentApprovalPage from '../NurseApp/Equipment/EquipmentApprovalPage';
import ShiftListPage from '../NurseApp/Shift/ShiftListPage';
import CreateShiftPage from '../NurseApp/Shift/CreateShiftPage';
import ShiftDetailPage from '../NurseApp/Shift/ShiftDetailPage';
import ShiftStatisticsPage from '../NurseApp/Shift/ShiftStatisticsPage';
import CreateShiftPlanPage from '../NurseApp/Shift/CreateShiftPlanPage';
import SubmitShiftPlanPage from '../NurseApp/Shift/SubmitShiftPlanPage';
import ReviewShiftPlanPage from '../NurseApp/Shift/ReviewShiftPlanPage';
import ShiftPlanListPage from '../NurseApp/Shift/ShiftPlanListPage';
import SwapRequestsPage from '../NurseApp/Shift/SwapRequestsPage';
import SwapHistoryPage from '../NurseApp/Shift/SwapHistoryPage';
import PlanSwapRequestsPage from '../NurseApp/Shift/PlanSwapRequestsPage';
import NurseProfilePage from '../NurseApp/Profile/NurseProfilePage';
import NurseSettingsPage from '../NurseApp/Settings/NurseSettingsPage';
import GiftHistoryPage from '../NurseApp/Gift/GiftHistoryPage';
import GamificationDashboardPage from '../NurseApp/Gamification/GamificationDashboardPage';
import NurseMarketplaceHome from '../NurseApp/Marketplace/NurseMarketplaceHome';
import NurseAppLandingPage from '../NurseApp/Landing/NurseAppLandingPage';
import MedQuizApp from '../../app-mothai';
import BottomNavigation from './BottomNavigation';

const AppContent = () => {
  const location = useLocation();
  const { currentUser } = useAuth();
  const [showDailyBonus, setShowDailyBonus] = useState(false);
  const [hasCheckedDailyBonus, setHasCheckedDailyBonus] = useState(false);
  
  // Pages ที่ไม่ต้องแสดง Navbar
  const hideNavbarPaths = ['/', '/login', '/register'];
  const shouldHideNavbar = hideNavbarPaths.includes(location.pathname) && !location.pathname.startsWith('/pharma-quiz');
  
  // Helper: สร้าง allowedRoles array สำหรับ Nurse App routes
  // รวมทั้ง ROLES.USER, ROLES.ADMIN และ JOB_ROLES ทั้งหมด
  const getNurseAppAllowedRoles = () => [
    ROLES.USER,
    ROLES.ADMIN,
    JOB_ROLES.NURSE,
    JOB_ROLES.ASSISTANT_NURSE,
    JOB_ROLES.DOCTOR,
    JOB_ROLES.STAFF,
    JOB_ROLES.ADMIN
  ];

  // Start video call reminder service
  useEffect(() => {
    const reminderIntervalId = startReminderService(1); // Check every 1 minute
    return () => {
      if (reminderIntervalId) {
        clearInterval(reminderIntervalId);
      }
    };
  }, []);

  // Set document title based on route
  useEffect(() => {
    const routeTitles = {
      '/': '',
      '/login': 'เข้าสู่ระบบ',
      '/register': 'สมัครสมาชิก',
      '/pharma-quiz': 'ติวข้อสอบ',
      '/mothai-quiz': 'ติวข้อสอบ',
      '/marketplace': 'ตลาดซื้อขาย',
    };
    
    const pageTitle = routeTitles[location.pathname] || '';
    // Detect ติวหมอไทย routes (pharma-quiz, root path, login, or register)
    const pathLower = location.pathname.toLowerCase();
    const isNurseApp = pathLower.startsWith('/nurse') || 
                       pathLower.startsWith('/pharma-quiz') ||
                       pathLower.startsWith('/mothai-quiz') ||
                       location.pathname === '/' || 
                       location.pathname === '/login' || 
                       location.pathname === '/register';
    setDocumentTitle(pageTitle, isNurseApp);
  }, [location.pathname]);

  // Check daily bonus when user logs in
  useEffect(() => {
    const checkDailyBonus = async () => {
      if (!currentUser || hasCheckedDailyBonus) return;
      
      try {
        const userRef = doc(db, 'users', currentUser.uid);
        const userSnap = await getDoc(userRef);
        
        if (userSnap.exists()) {
          const userData = userSnap.data();
          const streakData = userData.dailyBonusStreak || {};
          const lastClaim = streakData.lastClaimDate?.toDate?.() || 
                          (streakData.lastClaimDate instanceof Date ? streakData.lastClaimDate : null);
          
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          
          // ตรวจสอบว่า claim วันนี้แล้วหรือยัง
          const claimedToday = lastClaim && 
            lastClaim.getDate() === today.getDate() &&
            lastClaim.getMonth() === today.getMonth() &&
            lastClaim.getFullYear() === today.getFullYear();
          
          // แสดง modal ถ้ายังไม่ได้ claim วันนี้
          if (!claimedToday) {
            // Delay เล็กน้อยเพื่อให้หน้าเว็บโหลดเสร็จก่อน
            setTimeout(() => {
              setShowDailyBonus(true);
            }, 1500);
          }
        }
      } catch (error) {
        console.error('Error checking daily bonus:', error);
      } finally {
        setHasCheckedDailyBonus(true);
      }
    };
    
    // ตรวจสอบเฉพาะเมื่อ user login และยังไม่ได้ check
    if (currentUser && !hasCheckedDailyBonus && !shouldHideNavbar) {
      checkDailyBonus();
    }
  }, [currentUser, hasCheckedDailyBonus, shouldHideNavbar]);

  // Check if current route is Nurse App
  const isNurseAppRoute = location.pathname.startsWith('/nurse');

  return (
    <div className="min-h-screen bg-gray-50">
      {!shouldHideNavbar && !isNurseAppRoute && <Navbar />}
      {!shouldHideNavbar && isNurseAppRoute && <NurseTopNavbar />}
      <main className={shouldHideNavbar ? '' : isNurseAppRoute ? '' : 'container mx-auto px-4 py-6'}>
        <Routes>
          <Route path="/" element={<AngelCareWelcomePage />} />
          <Route path="/home" element={<MapHome />} />
          <Route path="/cannatrade" element={<WelcomePage />} />
          <Route path="/login" element={<LoginNew />} />
          <Route path="/register" element={<RegisterNew />} />
          
          {/* Pharma Quiz App - Public Route */}
          <Route path="/pharma-quiz" element={<MedQuizApp />} />
          <Route path="/mothai-quiz" element={<MedQuizApp />} />
          
          {/* Marketplace Routes - Redirect to pharma-quiz */}
          <Route 
            path="/marketplace" 
            element={<Navigate to="/pharma-quiz" replace />}
          />
          <Route 
            path="/marketplace/my-store" 
            element={
              <ProtectedRoute allowedRoles={[ROLES.USER, ROLES.FARM]}>
                <StoreManagement />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/marketplace/cart" 
            element={
              <ProtectedRoute allowedRoles={[ROLES.USER, ROLES.FARM]}>
                <Cart />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/marketplace/favorites" 
            element={
              <ProtectedRoute allowedRoles={[ROLES.USER, ROLES.FARM]}>
                <FavoritesPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/campaigns/my-banners" 
            element={
              <ProtectedRoute allowedRoles={[ROLES.USER, ROLES.FARM]}>
                <BannerDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/marketplace/orders" 
            element={
              <ProtectedRoute allowedRoles={[ROLES.USER, ROLES.FARM]}>
                <OrdersList />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/marketplace/orders/:orderId" 
            element={
              <ProtectedRoute allowedRoles={[ROLES.USER, ROLES.FARM]}>
                <OrderDetail />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/marketplace/auctions" 
            element={
              <ProtectedRoute allowedRoles={[ROLES.USER, ROLES.FARM]}>
                <AuctionsList />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/marketplace/my-auctions" 
            element={
              <ProtectedRoute allowedRoles={[ROLES.USER, ROLES.FARM]}>
                <AuctionManagement />
              </ProtectedRoute>
            } 
          />
          <Route path="/marketplace/auctions/:auctionId" element={<AuctionDetail />} />
          <Route path="/marketplace/products/:productId" element={<ProductDetail />} />
          <Route 
            path="/marketplace/products" 
            element={
              <ProtectedRoute allowedRoles={[ROLES.USER, ROLES.FARM]}>
                <ProductsList />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/marketplace/stores" 
            element={
              <ProtectedRoute allowedRoles={[ROLES.USER, ROLES.FARM]}>
                <StoresList />
              </ProtectedRoute>
            } 
          />
          <Route path="/marketplace/stores/:storeId" element={<StoreDetail />} />
          <Route 
            path="/marketplace/chat/:chatId" 
            element={
              <ProtectedRoute allowedRoles={[ROLES.USER, ROLES.FARM]}>
                <ChatPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/marketplace/video-call/:chatId" 
            element={
              <ProtectedRoute allowedRoles={[ROLES.USER, ROLES.FARM]}>
                <VideoCall />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/marketplace/video-call/product/:productId/store/:storeId" 
            element={
              <ProtectedRoute allowedRoles={[ROLES.USER, ROLES.FARM]}>
                <VideoCall />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/marketplace/buyer-requests" 
            element={
              <ProtectedRoute allowedRoles={[ROLES.USER, ROLES.FARM]}>
                <BuyerRequestManagement />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/marketplace/my-video-calls" 
            element={
              <ProtectedRoute allowedRoles={[ROLES.USER, ROLES.FARM]}>
                <MyVideoCallRequests />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/marketplace/farm-dashboard" 
            element={
              <ProtectedRoute allowedRoles={[ROLES.FARM]}>
                <FarmDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/profile" 
            element={
              <ProtectedRoute>
                <Navigate to="/profile/settings" replace />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/profile/settings" 
            element={
              <ProtectedRoute>
                <ProfileSettings />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/marketplace/reviews/:type/:id" 
            element={<ReviewsPage />} 
          />
          <Route path="/girl/:id" element={<GirlProfile />} />
          <Route path="/invite/:token" element={<AcceptInvitation />} />
          
          {/* Check-in Route */}
          <Route 
            path="/checkin/:tripId" 
            element={
              <ProtectedRoute allowedRoles={[ROLES.CUSTOMER, ROLES.MOMO, ROLES.GIRL, ROLES.ADMIN]}>
                <CheckinPage />
              </ProtectedRoute>
            } 
          />
          
          {/* Protected Routes */}
          <Route 
            path="/trip-plans" 
            element={
              <ProtectedRoute allowedRoles={[ROLES.CUSTOMER, ROLES.MOMO, ROLES.GIRL]}>
                <TripPlansPage />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/bookings" 
            element={
              <ProtectedRoute requiredRole={ROLES.CUSTOMER}>
                <BookingHistory />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/agoda" 
            element={
              <ProtectedRoute allowedRoles={[ROLES.CUSTOMER, ROLES.MOMO, ROLES.GIRL, ROLES.ADMIN]}>
                <AgodaPage />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute requiredRole={ROLES.ADMIN}>
                <AdminPanel />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/momo" 
            element={
              <ProtectedRoute requiredRole={ROLES.MOMO}>
                <MomoDashboard />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/girl" 
            element={
              <ProtectedRoute requiredRole={ROLES.GIRL}>
                <GirlDashboard />
              </ProtectedRoute>
            } 
          />

          {/* Debug Route - สำหรับตั้ง Admin Role */}
          <Route 
            path="/set-admin" 
            element={<SetAdminRole />} 
          />

          {/* Nurse App Landing Page - Public */}
          <Route 
            path="/nurse/Home" 
            element={<NurseAppLandingPage />} 
          />
          <Route 
            path="/nurse/home" 
            element={<NurseAppLandingPage />} 
          />
          
          {/* Nurse App Routes */}
          <Route 
            path="/nurse" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <NurseHomePage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/teams" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="teamManagement">
                  <TeamListPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/teams/:teamId" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="teamManagement">
                  <TeamDetailPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/teams/config" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="teamManagement">
                  <TeamConfigPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/teams/beds" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="teamManagement">
                  <BedManagementPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/equipment" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <EquipmentListPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/equipment/:id" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <EquipmentDetailPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/equipment/inspection" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <InspectionJourneyPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/equipment/inspection/:id" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <InspectionJourneyPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/equipment/inspection/success" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <InspectionSuccessPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/equipment/my-inspections" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <MyInspectionsPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/equipment/inspections/approval" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <InspectionApprovalDashboard />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/equipment/inspections/:id/review" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <InspectionReviewPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/equipment/inspections/compare" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <CompareInspectionsPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/equipment/stock" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <StockManagementPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/equipment/dashboard" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <EquipmentDashboardPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/equipment/catalog" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <CatalogManagementPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/equipment/create" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <CreateEquipmentPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/equipment/borrow" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <BorrowEquipmentPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/equipment/my-borrows" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <MyBorrowedEquipmentPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/equipment/borrows/management" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <BorrowManagementPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/equipment/repair" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <RepairRequestPage />
                </FeatureGuard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/nurse/equipment/repair/:id" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <RepairRequestPage />
                </FeatureGuard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/nurse/equipment/my-repairs" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <MyRepairRequestsPage />
                </FeatureGuard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/nurse/equipment/repairs/management" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <RepairManagementPage />
                </FeatureGuard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/nurse/equipment/approval" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <EquipmentApprovalPage />
                </FeatureGuard>
              </ProtectedRoute>
            }
          />
          <Route 
            path="/nurse/shifts" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="shiftManagement">
                  <ShiftListPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/shifts/create" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="shiftManagement">
                  <CreateShiftPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/shifts/:id" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="shiftManagement">
                  <ShiftDetailPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/shifts/statistics" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="shiftManagement">
                  <ShiftStatisticsPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/shifts/plans/create" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="shiftManagement">
                  <CreateShiftPlanPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/shifts/plans" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="shiftManagement">
                  <ShiftPlanListPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/shifts/plans/:planId/submit" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="shiftManagement">
                  <SubmitShiftPlanPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/shifts/plans/:planId/review" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="shiftManagement">
                  <ReviewShiftPlanPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/shifts/plans/:planId/equipment" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="equipmentManagement">
                  <EquipmentPlanManagementPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/shifts/swaps" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="shiftManagement">
                  <SwapRequestsPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/shifts/swaps/history" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="shiftManagement">
                  <SwapHistoryPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/shifts/swaps/plan-requests" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="shiftManagement">
                  <PlanSwapRequestsPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/profile" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <NurseProfilePage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/settings" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <NurseSettingsPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/profile/settings" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <NurseSettingsPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/gifts/history" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <GiftHistoryPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/gamification" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="gamification">
                  <GamificationDashboardPage />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          
          {/* Nurse App Marketplace Routes */}
          <Route 
            path="/nurse/marketplace" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="marketplace">
                  <NurseMarketplaceHome />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/marketplace/store/:storeId" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="marketplace">
                  <StoreDetail />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/marketplace/store/management" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="marketplace">
                  <StoreManagement />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/marketplace/products/:productId" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="marketplace">
                  <ProductDetail />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/marketplace/cart" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="marketplace">
                  <Cart />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/marketplace/orders" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="marketplace">
                  <OrdersList />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/marketplace/orders/:orderId" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="marketplace">
                  <OrderDetail />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/marketplace/products" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="marketplace">
                  <ProductsList />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/nurse/marketplace/stores" 
            element={
              <ProtectedRoute allowedRoles={getNurseAppAllowedRoles()}>
                <FeatureGuard feature="marketplace">
                  <StoresList />
                </FeatureGuard>
              </ProtectedRoute>
            } 
          />
          
        </Routes>
      </main>
      <PWAInstallPrompt />
      <LineBrowserPrompt />
      
      {/* Bottom Navigation - Show on quiz pages and other pages */}
      {!shouldHideNavbar && !isNurseAppRoute && <BottomNavigation />}
      
      {/* Daily Bonus Modal */}
      {currentUser && (
        <DailyBonusModal
          isOpen={showDailyBonus}
          onClose={() => setShowDailyBonus(false)}
        />
      )}
    </div>
  );
};

export default AppContent;

